// Utility function to parse string numbers into actual numbers
var parseThemeData = function (data) {
    var parseObject = function (obj) {
        var result = {};
        for (var key in obj) {
            var value = obj[key];
            if (typeof value === 'string' && !isNaN(parseFloat(value))) {
                // If the value is a string that can be parsed as a number, parse it
                result[key] = parseFloat(value);
            }
            else if (typeof value === 'object' && value !== null) {
                // Recursively parse nested objects
                result[key] = parseObject(value);
            }
            else {
                // Keep the value as-is (e.g., for strings like "#FFFFFF" or objects like createdOn)
                result[key] = value;
            }
        }
        return result;
    };
    return parseObject(data);
};
// Default theme (used if fetch fails)
var rawDefaultTheme = {
    id: "DYHOyEXAJXf3nWwBerbm",
    owner: "MFjurDBXZRR8AChkWBnujDEiyPB2",
    createdOn: {
        _seconds: 1741315078,
        _nanoseconds: 682000000,
    },
    name: "Default System Theme",
    foundations: {
        radius: {
            medium: {
                smallControl: "16",
                page: "32",
                container: "16",
                largeControl: "10",
            },
            expanded: {
                smallControl: "16",
                largeControl: "10",
                container: "16",
                page: "32",
            },
            compact: {
                largeControl: "10",
                container: "16",
                smallControl: "16",
                page: "24",
            },
        },
        size: {
            responsive: {
                expanded: "1200",
                medium: "720",
                maxPageBleed: "1500",
            },
            expanded: {
                large: "44",
                small: "32",
                base: "24",
            },
            compact: {
                large: "44",
                small: "32",
                base: "24",
            },
            medium: {
                large: "44",
                base: "24",
                small: "32",
            },
        },
        space: {
            compact: {
                hExtra: "6",
                hSmall: "4",
                content: "8",
                vExtra: "6",
                hSection: "8",
                hUnify: "4",
                vSection: "8",
                vSmall: "4",
                vUnify: "4",
            },
            expanded: {
                hUnify: "4",
                hSmall: "4",
                vSection: "16",
                hSection: "16",
                hExtra: "12",
                vUnify: "4",
                vExtra: "10",
                content: "8",
                vSmall: "4",
            },
            medium: {
                vExtra: "6",
                hUnify: "4",
                hExtra: "8",
                vUnify: "4",
                content: "8",
                hSmall: "4",
                hSection: "16",
                vSmall: "4",
                vSection: "16",
            },
        },
        color: {
            light: {
                textSecondaryAlpha: ".7",
                textPrimary: "#1d1e20",
                iconAlpha: ".8",
                accentAlpha: "1",
                notice: "#D4AC21",
                onPrimary: "#FFFFFF",
                fillContainer: "#555658",
                surfaceHoverAlpha: "0.08",
                negative: "#F95862",
                primaryAlpha: "1",
                divider: "#555658",
                backgroundElevated: "#FFFFFF",
                dividerAlpha: "0.15",
                surfaceDown: "#555658",
                fillControl: "#555658",
                icon: "#303036",
                informative: "#1488E1",
                backgroundFlat: "#F5F5F5",
                border: "#555658",
                surfaceDownAlpha: "0.04",
                readOnly: "#555658",
                readOnlyAlpha: "0.5",
                surfaceHover: "#555658",
                fillContainerAlpha: "0.06",
                borderAlpha: "0.12",
                fillControlAlpha: "0.09",
                textSecondary: "#1d1e20",
                textPrimaryAlpha: "1",
                positive: "#25B545",
                onAccent: "#FFFFFF",
                accent: "#3A3A3A",
                primary: "#000000",
            },
            dark: {
                surfaceHover: "#FFFFFF",
                notice: "#FFED47",
                iconAlpha: "0.7",
                textPrimaryAlpha: "1",
                dividerAlpha: "0.11",
                textSecondary: "#F5F5F5",
                backgroundElevated: "#1C1C1C",
                fillControlAlpha: "0.08",
                positive: "#15e088",
                fillContainerAlpha: "0.05",
                primaryAlpha: "1",
                borderAlpha: "0.1",
                readOnlyAlpha: ".4",
                border: "#FFFFFF",
                fillControl: "#FFFFFF",
                accentAlpha: "1",
                surfaceDownAlpha: "0.08",
                fillContainer: "#FFFFFF",
                backgroundFlat: "#121212",
                textPrimary: "#F5F5F5",
                textSecondaryAlpha: "0.7",
                divider: "#FFFFFF",
                icon: "#F5F5F5",
                readOnly: "#FFFFFF",
                surfaceHoverAlpha: "0.11",
                informative: "#1588e1",
                onPrimary: "#000000",
                negative: "#FF4C4C",
                onAccent: "#000000",
                surfaceDown: "#FFFFFF",
                accent: "#D4D4D4",
                primary: "#FFFFFF",
            },
        },
        text: {
            expanded: {
                title3LetterSpacing: "0",
                headlineLetterSpacing: "0",
                title2Size: "40",
                title1LineHeight: "56",
                subheadLineHeight: "20",
                bodyLineHeight: "24",
                title3LineHeight: "40",
                subheadSize: "14",
                caption1LetterSpacing: "0",
                caption2LineHeight: "14",
                caption1Size: "13",
                footnoteSize: "13",
                caption2LetterSpacing: "0",
                bodyLetterSpacing: "0",
                title2LineHeight: "44",
                headlineLineHeight: "24",
                title2LetterSpacing: "-.01",
                caption1LineHeight: "16",
                title3Size: "36",
                footnoteLetterSpacing: "0",
                title1Size: "48",
                footnoteLineHeight: "20",
                subheadLetterSpacing: "0",
                caption2Size: "12",
                bodySize: "16",
                headlineSize: "18",
                title1LetterSpacing: "-.01",
            },
            compact: {
                title3LineHeight: "32",
                title1Size: "40",
                title3Size: "28",
                headlineLetterSpacing: "0",
                caption1LetterSpacing: "0",
                subheadLetterSpacing: "0",
                caption1Size: "13",
                footnoteLetterSpacing: "0",
                title2LineHeight: "36",
                subheadSize: "14",
                title1LineHeight: "44",
                bodyLetterSpacing: "0",
                headlineLineHeight: "24",
                bodyLineHeight: "24",
                bodySize: "16",
                footnoteLineHeight: "20",
                caption2LineHeight: "14",
                title3LetterSpacing: "0",
                headlineSize: "18",
                title2Size: "32",
                title2LetterSpacing: "-.01",
                caption2LetterSpacing: "0",
                title1LetterSpacing: "-.01",
                caption2Size: "12",
                footnoteSize: "13",
                subheadLineHeight: "20",
                caption1LineHeight: "16",
            },
            medium: {
                bodyLineHeight: "24",
                footnoteLetterSpacing: "0",
                title1Size: "44",
                subheadSize: "14",
                headlineLetterSpacing: "0",
                title2LineHeight: "40",
                caption2LineHeight: "14",
                footnoteLineHeight: "20",
                footnoteSize: "13",
                headlineLineHeight: "24",
                caption2Size: "12",
                caption2LetterSpacing: "0",
                title3LineHeight: "36",
                subheadLetterSpacing: "0",
                caption1Size: "13",
                headlineSize: "18",
                bodyLetterSpacing: "0",
                caption1LetterSpacing: "0",
                title3LetterSpacing: "0",
                caption1LineHeight: "16",
                title2LetterSpacing: "-.01",
                title3Size: "32",
                title1LetterSpacing: "-.01",
                bodySize: "16",
                title1LineHeight: "48",
                title2Size: "36",
                subheadLineHeight: "20",
            },
            weight: {
                footnoteBold: "600",
                bodyLight: "400",
                footnoteLight: "300",
                footnote: "400",
                caption2Bold: "600",
                bodyBold: "600",
                subhead: "500",
                title2Regular: "400",
                title2: "600",
                subheadLight: "300",
                title2Light: "300",
                caption2: "600",
                headlineBold: "600",
                footnoteRegular: "400",
                body: "400",
                title1: "600",
                title1Light: "300",
                title3Light: "300",
                subheadRegular: "400",
                subheadBold: "600",
                caption1Bold: "600",
                title3Bold: "800",
                caption1Light: "400",
                headline: "600",
                title3Regular: "400",
                headlineRegular: "400",
                caption1: "600",
                title2Bold: "800",
                title1Bold: "800",
                headlineLight: "400",
                bodyRegular: "400",
                caption2Light: "400",
                title1Regular: "400",
                caption2Regular: "400",
                caption1Regular: "400",
                title3: "500",
            },
            family: {
                name: "",
                titleFallback: 'system-ui, "Segoe UI", Roboto, Helvetica, Arial, serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                fallback: 'system-ui, "Segoe UI", Roboto, Helvetica, Arial, serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                src: "",
                titleName: "",
                titleSrc: "",
            },
        },
    },
    css: "https://firebasestorage.googleapis.com/v0/b/system-style/o/DYHOyEXAJXf3nWwBerbm.css?alt=media&token=6d636aa1-2812-4bdf-8377-a279c96463a5",
    lastModified: {
        _seconds: 1741315548,
        _nanoseconds: 356000000,
    },
};
// Parse the raw theme data to convert string numbers to actual numbers
export var defaultTheme = parseThemeData(rawDefaultTheme);
